import {Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import {MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import {AppService} from '@app/app.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AppHelper} from '@app/core/app.helper';

@Component({
    selector: 'app-settings-table-name-dialog',
    templateUrl: './settings.table.name.dialog.component.html',
    styleUrls: ['./settings.table.name.dialog.component.css']
})
export class SettingsTableNameDialogComponent implements OnInit {
    /**
     * Объект формы
     */
    form: FormGroup;

    /**
     * Ссылка на объект формы
     */
    @ViewChild('formRef', {static: true}) formRef: ElementRef;

    /**
     * Конструктор
     * @param {FormBuilder} fb создатель форм
     * @param {AppService} appService сервис взаимодействия с внешними ресурсами
     * @param {MatDialogRef<SettingsTableNameDialogComponent>} dialogRef ссылка на диалог
     * @param {object} data данные для диалога
     */
    constructor(
        private fb: FormBuilder,
        public appService: AppService,
        public dialogRef: MatDialogRef<SettingsTableNameDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            title: string;
            name: string;
            type: string;
        }) {
    }

    /**
     * Событие окончания инициализации компонента
     */
    ngOnInit() {
        this.form = this.fb.group({
            name: [this.data.name, [Validators.required]]
        });
    }

    /**
     * Сохранение данных
     */
    save() {
        if (this.form.valid) {
            let name = this.form.value.name;

            switch (typeof name) {
                case 'string':
                    name = name.trim();
                    break;
            }

            this.dialogRef.close({
                save: true,
                name
            });
        } else {
            AppHelper.validateAllFormFields(this.form);
            const target = this.formRef.nativeElement.querySelector('.mat-select.ng-invalid, .mat-input-element.ng-invalid, .mat-checkbox-input.ng-invalid');
            setTimeout(() => {
                if (target.querySelector('input')) {
                    target.querySelector('input').focus();
                }
            }, 0);
        }
    }

    /**
     * закрытие диалога
     */
    close() {
        this.dialogRef.close({save: false});
    }
}
